// extracted by mini-css-extract-plugin
export default {"overview__container":"AntiTiltOverview_overview__container__YZyyB"};